import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Link, useHistory } from 'react-router-dom'
import Button from 'react-bootstrap/Button'
import Dropdown from 'react-bootstrap/Dropdown'
import { setLoginRoleAndVerify, fetchProfile, userLogout, userFakeLogin } from 'actions/basic/actions'

function LoginButton() {
  const lang = useSelector((s) => s.front.lang)
  const token = useSelector((s) => s.login.token)
  const role = useSelector((s) => s.login.role)
  const access = useSelector((s) => s.login.access)
  const name = useSelector((s) => s.login.name)
  const name_en = useSelector((s) => s.login.data.name_en)
  const dispatch = useDispatch()
  const history = useHistory()

  let content = {
    english: {
      switch_student: 'Change to student',
      switch_tutor: 'Change to tutor',
      profile: 'Basic Information',
      sign_out: 'Sign out',
      sign_in: 'Sign in',
    },
    chinese: {
      switch_student: '切換學生身份',
      switch_tutor: '切換小老師身份',
      profile: '基本資訊',
      sign_out: '登出',
      sign_in: '登入',
    },
  }

  if (lang === 'zh') {
    content = content.chinese
  } else if (lang === 'en') {
    content = content.english
  }

  const changeRole = (r) => {
    dispatch(setLoginRoleAndVerify(r, token))
    history.push('/basic')
  }

  useEffect(() => {
    if (token != '' && name === '') {
      dispatch(fetchProfile(token))
    }
  }, [token])

  const fakeLogin = () => {
    dispatch(userFakeLogin())
  }

  const logout = () => {
    dispatch(userLogout())
    history.push('/basic')
  }

  if (token !== '') {
    let dropdown_item = []
    if (access.student && role !== 'student') {
      dropdown_item.push(
        <Dropdown.Item onClick={() => changeRole('student')} key='basic_student'>
          {content.switch_student}
        </Dropdown.Item>
      )
    }
    if (access.tutor) {
      if (role === 'tutor')
        dropdown_item.push(
          <Link to='/basic/profile' key='basic_profile'>
            <Dropdown.Item href='.'>{content.profile}</Dropdown.Item>
          </Link>
        )
      else
        dropdown_item.push(
          <Dropdown.Item onClick={() => changeRole('tutor')} key='basic_tutor'>
            {content.switch_tutor}
          </Dropdown.Item>
        )
    }
    if (access.admin) {
      dropdown_item.push(
        <Link to='/basic_db' key='basic_db'>
          <Dropdown.Item href='.'>前往後台</Dropdown.Item>
        </Link>
      )
    }

    return (
      <Dropdown className='text-right'>
        <Dropdown.Toggle variant='orange' className='loginButton'>
          {'Hi, ' + (lang === 'zh' ? name : name_en)}
        </Dropdown.Toggle>

        <Dropdown.Menu>
          {dropdown_item}
          <Dropdown.Item onClick={logout}>{content.sign_out}</Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    )
  } else {
    if (process.env.NODE_ENV === 'production')
      return (
        <Button
          href={`${process.env.REACT_APP_BACKEND_API}/en/basic/api/signin/student?to=${
            window.location.href.split(/[?#]/)[0]
          }?role=student`}
          variant='orange'
          className='loginButton'
        >
          {content.sign_in}
        </Button>
      )
    else
      return (
        <Button variant='orange' onClick={fakeLogin} className='loginButton'>
          {content.sign_in}
        </Button>
      )
  }
}

export default LoginButton
